import { render, staticRenderFns } from "./TicketsRedirect.vue?vue&type=template&id=8926ef8e&"
import script from "./TicketsRedirect.vue?vue&type=script&lang=js&"
export * from "./TicketsRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports